import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyDV26JGwoPUjWH_xcs7TpX6vLZeAP-THYQ",
    authDomain: "fesimeoni-nonbainary.firebaseapp.com",
    databaseURL: "https://fesimeoni-nonbainary-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "fesimeoni-nonbainary",
    storageBucket: "fesimeoni-nonbainary.appspot.com",
    messagingSenderId: "409419870344",
    appId: "1:409419870344:web:108f18255da0b52ab8ef3d"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db };